<template>
    <div class="footer-button" :isFixed="isFixed" :style="isFixed ? fixedStyle : {}">
        <ion-button mode="ios" expand="full" color="primary" :disabled="disabled" @click="clickEvent">{{ label }}</ion-button>
    </div>
</template>

<script>
    export default {
        name: "FooterOneButtonbar",
        props: {
            label: String,
            disabled: Boolean,
            isFixed: Boolean
        },
        data() {
            return {
                fixedStyle: {
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "49px"
                }
            }
        },
        methods: {
            clickEvent() {
                this.$emit("footerButtonEvent");
            }
        }
    }
</script>

<style scoped lang="scss">
    div.footer-button {
        ion-button {
            width: 100%;
            margin: 0;
            font-size: 17px;
            font-weight: $font-weight700;
            color: white;
        }
    }
</style>
